import TopBanner from "@/_component/Common/ads/topbanner/TopBanner";
import BottomBanner from "@/_component/Common/ads/bottombanner/BottomBanner";
import RightBanner from "@/_component/Common/ads/rightbanner/RightBanner";
import { useAdsRefresh } from "@/hooks/ads-refresh";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { userAddress } from "@/apis";

export default function MainAdsLayout({ children, sideBanner = false, className = "", noSpacing = false, hideTopBanner = false }) {
    const [stateIds, setStateIds] = useState(null);

    const initData = async () => {
        const category = sessionStorage.getItem("selectedDrop");
        if (category !== null && category !== "") {
            await getCategoryAddressList(category);
        }
    }

    const getCategoryAddressList = async (selectedCategory) => {
        const response = await userAddress(selectedCategory);
        let states = await response.data.response?.map(obj => obj.state);
        const uniqueStates = new Set(states);
        states = [...uniqueStates];
        setStateIds(states.join(","));
    }

    useEffect(() => {
        initData();
    }, []);

    useAdsRefresh(stateIds);

    function showSideBanner() {
        if (sideBanner) {
            return (
                <div className="d-flex flex-column flex-lg-row gap-4 gap-lg-5">
                    <div className="flex-fill">
                        {children}
                    </div>
                    <div className="pt-5 pt-lg-0"><RightBanner stateIds={stateIds} /></div>
                </div>
            )
        }
        return children;
    }

    return (
        <main>
            {!hideTopBanner && <TopBanner stateIds={stateIds} />}
            <section className="bg-light">
                <div className={classNames("container position-relative rounded-3 bg-white", !hideTopBanner ? "top-n5" : "mt-4", className, !noSpacing && "py-5 px-md-5 px-3")}>
                    {showSideBanner()}
                </div>
            </section>
            <BottomBanner stateIds={stateIds} />
        </main>
    );
}